import { useSearchParams } from 'react-router-dom';
import { DefaultLayout } from '@@shared/layouts/DefaultLayout';
import PaymentCard from './cards/PaymentSuccessfulCard';

export function PaymentSuccessfulPage() {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('paymentId');

  return (
    <DefaultLayout>
      <div className="flex min-h-full items-start justify-center bg-vk-beige p-4 pt-[15vh]">
        <div className="w-full max-w-md">
          <PaymentCard paymentId={paymentId} />
        </div>
      </div>
    </DefaultLayout>
  );
}
